<!-- 조직관리 > 관리자관리 리스트 -->
<template>
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="sort-group">
        <div class="sort-row">
          <div class="wl">
            <div class="txt-total">Total: {{ totalCnt }}</div>
            <c-InputSearch :placeholder="t('message.searchMultiPlaceholder')"  v-model="inputSearch" @search-word="onClickSearch"/>
          </div>
          <div class="wr">
            <c-btn01 v-bind="btnEachUpload" @click="onClickViewPage3"/>
          </div>
        </div>
      </div>
      <!-- v-data-table 가져옴-->
      <div class="tbl-group size-custom2">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          item-value="id"
          :items-per-page-options="footerOptions"
          return-object
          show-select
          @click:row="onClickViewPage3"
          :no-data-text="t('message.noRegisteredData')"
        >
          <template v-slot:item.idx="{ index }">
            {{ index + 1 }}
          </template>
          <template v-slot:item.regDate="{ item }" >
            <div class="ell01">
              {{ dayjs(item.regDate).format('YYYY-MM-DD') == 'Invalid Date' ? '' : dayjs(item.regDate).format('YYYY-MM-DD HH:mm:ss') }}
            </div>
          </template>
        </v-data-table>
      </div>
      <div class="bottom-btn-group">
        <div class="wl"></div>
        <div class="wr">
          <c-btnLine01 v-bind="btnListDel" @click="onClickDelete"/>
        </div>
      </div>
    </div>
  </div>
  <c-dialog v-model="dialogAllDeleteModel"
            v-bind="dialogAllDeleteBind"
            @close="dialogAllDeleteModel=false"
            @confirm="confirmDelete"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>
<style lang="scss" >
</style>
<script setup lang="ts">
import {ref, onMounted, computed} from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import MemberService from "@/services/member.service";
import utils from "@/common/Utils";
import dayjs from "dayjs";
import {useRoute} from "vue-router";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//ui
const dialogAllDeleteBind = {
  dialogTit: t('message.deleteAdmin'),
  dialogText: t('message.deleteAdminDescription'),
  btn1Text: t('message.delete'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}

//bind
const snackbar = ref(false)
const snackText = ref('')
const totalCnt = ref(0)
const inputSearch = ref(null)
const selected = ref([])
const items = ref([])
const dialogAllDeleteModel = ref(false)

//ui
const btnEachUpload = {
  btnText: t('message.individualRegistration'),
}

const btnListDel = {
  btnText: t('message.selectDelete'),
}
const headers = computed(() =>([
  { title: t('message.orderNumber'), key: 'idx' },
  { title: t('message.id'), key: 'memberId' },
  { title: t('message.name'), key: 'memberName'},
  { title: t('message.department'), key: 'deptName' },
  { title: t('message.position'), key: 'posName'},
  { title: t('message.shiftWork'), key: 'shiftYn' },
  { title: t('message.registrationDate'), key: 'regDate' },
  { title: t('message.isActive'), key: 'useYn' },
]))
const footerOptions = [
  { value: 5, title: '5' },
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
]

//hook
onMounted(() => {
  onClickSearch('')
})

//function
function onClickSearch(word){
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    keyword: word,
    companyIdx:companyIdx
  }

  MemberService.getCompanyAdminList(params).then(
    (response) => {
      items.value = response.result
      totalCnt.value = response.result.length
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

function onClickViewPage3(event, row){
  if(row)
    utils.movePage('/organizationalManagement/3/view/'+row.item.idx)
  else
    utils.movePage('/organizationalManagement/3/view/')
}

const onClickDelete = ()=>{
  if(selected.value.length <= 0){
    snackText.value = t('message.noDataSelected')
    snackbar.value = true
  }
  else {
    if(selected.value.length)
      dialogAllDeleteModel.value = true
  }
}

const confirmDelete=()=>{
  if(import.meta.env.MODE == 'development') {
    selected.value.forEach((item)=>{
      const idx = items.value.findIndex(function(tempItem) {return tempItem.idx === item.idx})
      if (idx > -1) items.value.splice(idx, 1)
    })

    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let updateArr = []
    selected.value.forEach((item)=>{
      updateArr.push(item.idx)
    })
    let params = {
      companyIdx:companyIdx,
      adminArr: updateArr,
    }

    MemberService.deleteCompanyAdmin(params).then(
      (response) => {
        if(response.success) {
          selected.value.forEach((item)=>{
            const idx = items.value.findIndex(function(tempItem) {return tempItem.idx === item.idx})
            if (idx > -1) items.value.splice(idx, 1)
          })

          selected.value = []
          snackText.value = 'success'
          snackbar.value = true
        }
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}
</script>

